/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState, useEffect } from 'react';
import { LandingPage, HtmlPage } from '../../../widgets/landing-page-widget';

import { useTheme } from '../../../providers/theme';
import { useSMProductLandingPage } from '../machines/pageContent';
import { CustomMetaTags } from '../../../widgets/custom-meta-titles';
import { VApplication } from '../../../application';
import { ProductLandingPageService } from '../../../services';
import { VerifiedUser, VerifyUser } from '../components';
import { useHistory } from 'react-router-dom';

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync(
    'services.ProductLandingPageService'
  ) as ProductLandingPageService;
};

export const ContainerComm = (props: any) => {
  const theme = useTheme();
  const history = useHistory();
  const [buttonItem, setButtonItem] = useState();
  const srv = getSrv();
  const staticPageContentConfig = srv?.getStaticPageContent();
  useEffect(() => {
    async function getNavItems() {
      let _navlinks = await srv?.getHeaderNavItems();
      console.log(`nav items`, _navlinks);
      if (_navlinks) {
        setButtonItem(_navlinks);
      }
    }
    setTimeout(() => {
      getNavItems();
    }, 500);
  }, []);

  const {
    productLandingPageMachine,
    productLandingPageState,
    productLandingPageSend,
  } = useSMProductLandingPage({});

  const _renderPage = () => {
    console.log(`staticPageContentConfig : `, staticPageContentConfig);
    if (productLandingPageState?.matches('RENDER_PAGE')) {
      return (
        <>
          <CustomMetaTags
            {...(productLandingPageState?.event?.data?.value?.metaData || {})}
          />
          <HtmlPage
            {...(productLandingPageState?.event?.data?.value || {})}
            secondaryColor={theme?.colors?.secondary}
            buttonItem={buttonItem}
            landingPage={true}
          >
            {staticPageContentConfig?.prodId === '5678' ? (
              <VerifiedUser
                {...staticPageContentConfig?.pageContent?._5678}
                onButtonClick={() => history.push('/product/5678')}
              />
            ) : staticPageContentConfig?.prodId === '5679' ? (
              <VerifiedUser
                {...staticPageContentConfig?.pageContent?._5679}
                onButtonClick={() => history.push('/product/5679')}
              />
            ) : staticPageContentConfig?.prodId === '1234' ? (
              <VerifyUser {...staticPageContentConfig?.pageContent?._1234} />
            ) : (
              <div />
            )}
          </HtmlPage>
        </>
      );
    }
    if (productLandingPageState?.matches('GET_PAGE_CONTENT')) {
      return <div>Loading...</div>;
    }
    return null;
  };
  return <>{_renderPage()}</>;
};
